export default {
  '10-11': {
      de: [
          ["Mitte", 52.530644, 13.383068],
          ["Spandau", 52.5333, 13.1667],
          ["Tegel", 52.5833, 13.2833],
          ["Kreuzberg", 52.498605, 13.391799],
          ["Pankow", 52.582501, 13.431302],
          ["Zehlendorf", 52.433959, 13.258909],
          ["Marzahn", 52.55, 13.55],
          ["Charlottenburg", 52.5143368063816, 13.2575955433331],
          ["Lichtenberg", 52.5215524721497, 13.4970212409089],
          ["Köpenick", 52.4397061114459, 13.6051061706892],
          ["Schöneberg", 52.4801398457587, 13.3544148048569]
      ]
  },

  // display this labels between zoom levels 11-18
  '18-20': {
      de: [
          ["Schmöckwitz", 52.3750786537842, 13.6540983961853],
          ["Lichtenrade", 52.394483127051, 13.4044722393629],
          ["Bohnsdorf", 52.398215448611, 13.5648763143976],
          ["Grünau", 52.4054771719123, 13.59578895166],
          ["Müggelheim", 52.4070157478224, 13.6835944351654],
          ["Marienfelde", 52.4100746800773, 13.3707605751069],
          ["Buckow", 52.4101165487515, 13.4071582750054],
          ["Altglienicke", 52.4125834059449, 13.5405663751799],
          ["Rudow", 52.4168213181983, 13.4955021829871],
          ["Wannsee", 52.4198311257887, 13.1412226085858],
          ["Lichterfelde", 52.426418005187, 13.3064856734882],
          ["Gropiusstadt", 52.4265740290095, 13.4641415595655],
          ["Lankwitz", 52.4318654922701, 13.3484792153414],
          ["Adlershof", 52.4357379838587, 13.543168944006],
          ["Zehlendorf", 52.4369794428078, 13.2476934628185],
          ["Mariendorf", 52.4385070997892, 13.3909016468247],
          ["Köpenick", 52.4397061114459, 13.6051061706892],
          ["Nikolassee", 52.4429576303135, 13.1983919038669],
          ["Johannisthal", 52.4438679560449, 13.5042779170755],
          ["Britz", 52.4439462726345, 13.436724219962],
          ["Rahnsdorf", 52.4441470264956, 13.7029520637815],
          ["Niederschöneweide", 52.4528042262805, 13.5252209583941],
          ["Steglitz", 52.4552045019433, 13.3324379918337],
          ["Baumschulenweg", 52.4570079091145, 13.4810311998478],
          ["Dahlem", 52.4577542915101, 13.2783830066155],
          ["Friedrichshagen", 52.4579205684187, 13.6378683733516],
          ["Kladow", 52.4609990979139, 13.1409776384339],
          ["Oberschöneweide", 52.4652627685706, 13.5282112785643],
          ["Tempelhof", 52.4664956997151, 13.3907250302453],
          ["Friedenau", 52.4721683924246, 13.3297419666895],
          ["Neukölln", 52.4751365184143, 13.441396509718],
          ["Schmargendorf", 52.4787304915072, 13.2919345371113],
          ["Plänterwald", 52.479550973093, 13.4796328950337],
          ["Schöneberg", 52.4801398457587, 13.3544148048569],
          ["Karlshorst", 52.4833875940902, 13.5294639791485],
          ["Gatow", 52.4850724559361, 13.1672136527093],
          ["Grunewald", 52.4854573264762, 13.235884282201],
          ["Wilmersdorf", 52.4857506210812, 13.3183838932364],
          ["Alt-Treptow", 52.4900187855895, 13.4604550416933],
          ["Kreuzberg", 52.4967623276816, 13.4051991446674],
          ["Halensee", 52.4970105589973, 13.29447863068],
          ["Rummelsburg", 52.4974599329834, 13.4917759740641],
          ["Kaulsdorf", 52.5027130796906, 13.588176090167],
          ["Friedrichsfelde", 52.5028381818224, 13.5173174175962],
          ["Mahlsdorf", 52.5029959691793, 13.6171149464757],
          ["Biesdorf", 52.5073191473512, 13.559362377031],
          ["Tiergarten", 52.5104619273268, 13.3581727334197],
          ["Friedrichshain", 52.5112104055802, 13.4524212926605],
          ["Westend", 52.5127704096797, 13.2529316405022],
          ["Charlottenburg", 52.5143368063816, 13.3075955433331],
          ["Wilhelmstadt", 52.5145446105831, 13.1901059043585],
          ["Hansaviertel", 52.5185375544768, 13.3417840232181],
          ["Mitte", 52.5212935576426, 13.3978429424815],
          ["Lichtenberg", 52.5215524721497, 13.4970212409089],
          ["Fennpfuhl", 52.529204346619, 13.4726637222145],
          ["Moabit", 52.5293468628701, 13.3432357539875],
          ["Staaken", 52.5317846717596, 13.1437008939292],
          ["Hellersdorf", 52.5339289111355, 13.6007817716325],
          ["Spandau", 52.5360053435403, 13.2024819997951],
          ["Siemensstadt", 52.5392150568328, 13.257545333457],
          ["Prenzlauer Berg", 52.5397472203792, 13.4307028153578],
          ["Charlottenburg-Nord", 52.5405305273359, 13.2975172118337],
          ["Marzahn", 52.5447441212464, 13.5524884205528],
          ["Haselhorst", 52.5453472859661, 13.2297935737216],
          ["Alt-Hohenschönhausen", 52.5460779953003, 13.5013265154504],
          ["Gesundbrunnen", 52.5506152663399, 13.3844851040835],
          ["Wedding", 52.5508534743357, 13.3415469544363],
          ["Falkenhagener Feld", 52.5519178263344, 13.1680011063968],
          ["Weißensee", 52.555253195594, 13.4625287165087],
          ["Neu-Hohenschönhausen", 52.5668275843389, 13.5125436468399],
          ["Pankow", 52.5671392951158, 13.4145576079858],
          ["Heinersdorf", 52.5706299931313, 13.4410247490434],
          ["Reinickendorf", 52.5717083389683, 13.3452313630494],
          ["Hakenfelde", 52.5743737010017, 13.1858292400831],
          ["Falkenberg", 52.5757524756335, 13.549652336447],
          ["Malchow", 52.5775630307961, 13.4875705013789],
          ["Tegel", 52.5816477262999, 13.270001773257],
          ["Konradshoehe", 52.5818271672715, 13.2261604896172],
          ["Niederschönhausen", 52.5819422200259, 13.3979102683342],
          ["Wartenberg", 52.5837258141448, 13.5173949745827],
          ["Borsigwalde", 52.5843686137957, 13.3074015867618],
          ["Wilhelmsruh", 52.5874929800792, 13.363537407943],
          ["Blankenburg", 52.5925502456423, 13.4566519958492],
          ["Wittenau", 52.592656923328, 13.3278106619498],
          ["Rosenthal", 52.596354965727, 13.3895188560189],
          ["Märkisches Viertel", 52.5993199178922, 13.3555760690729],
          ["Waidmannslust", 52.6068873391595, 13.3197083556475],
          ["Karow", 52.612169075781, 13.4795906730267],
          ["Heiligensee", 52.6124588720641, 13.2334697154418],
          ["Französisch Buchholz", 52.612702399944, 13.4380943402915],
          ["Lübars", 52.6152238098955, 13.3542908937553],
          ["Hermsdorf", 52.617250756914, 13.3068434147348],
          ["Blankenfelde", 52.6233976610817, 13.3989693162567],
          ["Frohnau", 52.640142238526, 13.2893458066799],
          ["Buch", 52.6427109134313, 13.4785529222834]
      ]
  }
}